import { render, staticRenderFns } from "./ECMRView.vue?vue&type=template&id=487daeca&scoped=true&"
import script from "./ECMRView.vue?vue&type=script&lang=ts&"
export * from "./ECMRView.vue?vue&type=script&lang=ts&"
import style0 from "./ECMRView.vue?vue&type=style&index=0&id=487daeca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487daeca",
  null
  
)

export default component.exports